import { Injectable, inject } from '@angular/core';
import { IFacturacionEnCurso } from 'modelos/src';
import { HttpClientService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class GastosService {
  private http = inject(HttpClientService);

  /** Facturación en curso (estimado vs real) del cliente autenticado. */
  public getFacturacionEnCurso(): Promise<IFacturacionEnCurso> {
    return this.http.get(`/gastos/facturacion-en-curso`);
  }

  /** Si el cliente autenticado puede ver Gastos (nivel 1 o raíz independiente). */
  public esFacturable(): Promise<{ facturable: boolean }> {
    return this.http.get(`/gastos/es-facturable`);
  }

  /** Dispara la generación del resumen mensual de un cliente (background). */
  public generarResumen(
    anio: number,
    mes: number,
    idCliente: string,
  ): Promise<{ iniciado: boolean }> {
    return this.http.post(`/gastos/generar-resumen`, { anio, mes, idCliente });
  }
}
